import { render, staticRenderFns } from "./ProjectTopCard.vue?vue&type=template&id=43beaada&scoped=true"
import script from "./ProjectTopCard.vue?vue&type=script&lang=js"
export * from "./ProjectTopCard.vue?vue&type=script&lang=js"
import style0 from "./ProjectTopCard.vue?vue&type=style&index=0&id=43beaada&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43beaada",
  null
  
)

export default component.exports